/**
 * All admin areas grouped under Settings (sidebar hub + route titles).
 * Sorted longest-path-first for prefix matching (nested routes).
 */
const SETTINGS_NAV_RAW = [
  {
    path: '/mail-settings',
    label: 'Mail & templates',
    description: 'SMTP credentials and registration/order emails.',
    icon: '✉',
    group: 'system',
  },
  {
    path: '/permissions',
    label: 'Permissions',
    description: 'Roles and API permissions.',
    icon: '◉',
    group: 'system',
  },
  {
    path: '/currencies',
    label: 'Currencies',
    description: 'Exchange rates and symbols for pricing.',
    icon: '¤',
    group: 'store',
  },
  {
    path: '/countries',
    label: 'Countries',
    description: 'Allowed countries for addresses.',
    icon: '◒',
    group: 'store',
  },
  {
    path: '/shipping-rates',
    label: 'Shipping rates',
    description: 'Shipping quotes by destination.',
    icon: '▤',
    group: 'store',
  },
  {
    path: '/product-settings',
    label: 'Product settings',
    description: 'Listing duration and product defaults.',
    icon: '▣',
    group: 'store',
  },
  {
    path: '/home-banner',
    label: 'Home banner',
    description: 'Home screen banner images and copy.',
    icon: '▧',
    group: 'app',
  },
  {
    path: '/notifications',
    label: 'Push notifications',
    description: 'Send push messages to app users.',
    icon: '◎',
    group: 'app',
  },
  {
    path: '/mobile-app-version',
    label: 'Mobile app version',
    description: 'Minimum version and force-update policy.',
    icon: '◷',
    group: 'app',
  },
];

export const SETTINGS_GROUPS = [
  { key: 'store', label: 'Store & shipping' },
  { key: 'app', label: 'Mobile app' },
  { key: 'system', label: 'System & access' },
];

export const SETTINGS_NAV_ITEMS = [...SETTINGS_NAV_RAW].sort(
  (a, b) => b.path.length - a.path.length,
);

export const SETTINGS_DISPLAY_ITEMS = [...SETTINGS_NAV_RAW].sort((a, b) =>
  a.label.localeCompare(b.label),
);

export function matchSettingsSection(pathname) {
  const p = pathname || '';
  if (p === '/settings') {
    return { label: 'Settings' };
  }
  const hit = SETTINGS_NAV_ITEMS.find(
    (item) => p === item.path || p.startsWith(`${item.path}/`),
  );
  return hit ? { label: hit.label } : null;
}

export function isUnderSettingsArea(pathname) {
  const p = pathname || '';
  if (p === '/settings') return true;
  return SETTINGS_NAV_ITEMS.some((item) => p === item.path || p.startsWith(`${item.path}/`));
}
